// extracted by mini-css-extract-plugin
module.exports = {"saleTag":"SaleTagIcon_saleTag__Ii_Oe"};